<template>
    <ul class="prize-list">
        <li v-for="(item, index) in list" :key="index" class="prize-list-item">
            <img :src="item" alt="" class="prize-list-img" />
        </li>
    </ul>
</template>

<script>
export default {
    name: 'PrizeList',
    props: {
        list: {
            type: Array,
            required: true
        }
    }
};
</script>

<style scoped>
.prize-list {
    width: 300px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center;
    padding: 0;
    margin: 0 auto;
    list-style: none;
    margin-bottom: 18px;
}
.prize-list-item {
    width: 96px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
}
.prize-list-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}
</style>
